import { Typography } from '@mui/material';


function Terms(){
	
	return (
    <div className='container' style={{ padding: "64px 1vw 64px 3vw" }}>
      <Typography variant="h4" component="h4" mb={4}>
      Terms and Conditions
      </Typography>
      
									<p>In using this website you are deemed to have read and agreed
									to the following terms and conditions:</p>
									<p>The following terminology applies to these Terms and
									Conditions, Privacy Statement and any or all
									Agreements: "You" and "Your" refers to you, the person
									accessing this website and accepting the miwatchfaces.com's terms and
									conditions. "miwatchfaces.com", "The Company", "Ourselves", "We" and
									"Us", refers to our Company. "Party", "Parties", or "Us", refers to
									both You and miwatchfaces.com, or either You or miwatchfaces.com. Any use of
									the above terminology or other words in the singular, plural,
									capitalization and/or he/she or they, are taken as interchangeable
									and therefore as referring to same.</p>
									<h3>Exclusions and Limitations</h3>
									<p>The information on this website is provided on an "as is"
									basis. To the fullest extent permitted by law, miwatchfaces.com:
									excludes all representations and warranties relating to this website
									and its contents or which is or may be provided by any affiliates or
									any other third party, including in relation to any inaccuracies or
									omissions in this website and/or the miwatchfaces.com's literature; and
									excludes all liability for damages arising out of or in connection
									with your use of this website. This includes, without limitation,
									direct loss, loss of business or profits (whether or not the loss of
									such profits was foreseeable, arose in the normal course of things
									or you have advised miwatchfaces.com of the possibility of such
									potential loss), damage caused to your computer, computer software,
									systems and programs and the data thereon or any other direct or
									indirect, consequential and incidental damages.</p>
									<h3>Termination of Agreements</h3>
									<p>Both You and miwatchfaces.com have the right to terminate any
									Services Agreement for any reason, including the ending of services
									that are already underway. No refunds shall be offered, where a
									Service is deemed to have begun and is, for all intents and
									purposes, underway.</p>
									<h3>Availability</h3>
									<p>You are solely responsible for evaluating the fitness for a
									particular purpose of any downloads, programs and text available
									through this site. Redistribution or republication of any part of
									this site or its content is prohibited, including such by framing or
									other similar or any other means, without the express written
									consent of miwatchfaces.com. miwatchfaces.com does not warrant that the
									service from this site will be uninterrupted, timely or error free,
									although it is provided to the best ability. By using this service
									you thereby indemnify this miwatchfaces.com, its employees, agents and
									affiliates against any loss or damage, in whatever manner, howsoever
									caused.</p>
									<h3>Log Files</h3>
									<p>We use IP addresses to analyse trends, administer the site,
									track user's movement, and gather broad demographic information for
									aggregate use. IP addresses are not linked to personally
									identifiable information. Additionally, for systems administration,
									detecting usage patterns and troubleshooting purposes, our web
									servers automatically log standard access information including
									browser type, access times/open mail, URL requested, and referral
									URL. This information is not shared with third parties and is used
									only within this Company on a need-to-know basis. Any individually
									identifiable information related to this data will never be used in
									any way different to that stated above without your explicit
									permission.</p>
									<h3>Force Majeure</h3>
									<p>Neither party shall be liable to the other for any failure to
									perform any obligation under any Agreement which is due to an event
									beyond the control of such party including but not limited to any
									Act of God, terrorism, war, Political insurgence, insurrection,
									riot, civil unrest, act of civil or military authority, uprising,
									earthquake, flood or any other natural or man made eventuality
									outside of our control, which causes the termination of an agreement
									or contract entered into, nor which could have been reasonably
									foreseen.</p>
									<h3>Waiver</h3>
									<p>Failure of either Party to insist upon strict performance of
									any provision of this or any Agreement or the failure of either
									Party to exercise any right or remedy to which it, he or they are
									entitled hereunder shall not constitute a waiver thereof and shall
									not cause a diminution of the obligations under this or any
									Agreement. No waiver of any of the provisions of this or any
									Agreement shall be effective unless it is expressly stated to be
									such and signed by both Parties.</p>
									<h3>Copyrighted or Trademarked Material</h3>
									<p>Uploaded content containing copyrighted or trademarked
									material will be removed at the request of the copyright or trademark
									owner. If you are a copyright or trademark owner who believes that
									your copyright or trademark is being infringed upon, please mail us at admin@miwatchfaces.com
									</p>
									<h3>Content (user uploads)</h3>
									<p>When posting materials (uploading files) on miwatchfaces.com, 
									the User provides the Administration and Owners of the Website (miwatchfaces.com) with
									the full right of free use and distribution of the specified materials (files).</p>
									<h3>Notification of Changes</h3>
									<p>miwatchfaces.com reserves the right to change these conditions
									from time to time as it sees fit, and your continued use of the site
									will signify your acceptance of any adjustment to these terms. You
									are therefore advised to re-read this statement on a regular basis.</p>
									<p>These terms and conditions form part of the Agreement between
									the You and miwatchfaces.com. Your accessing of this website indicates
									your understanding, agreement to and acceptance the full Terms and
									Conditions contained herein.</p>
      
    </div>
	);
}
export default Terms